import { useContext } from "react";
import { ReportPdfContext } from "src/utils/contexts";

export const CodeEditorView = (props) => {
  const { reportPdfView } = useContext(ReportPdfContext)
  const { code } = props;
  const preLineNumber = code.split("\n")
  .map((line, i) => i + 1)
  .join("\n");

  return (
    <div className={`editor ${code ? "editor-height" : ""} ${reportPdfView ? "pdf" : ""}`}>
      <pre className="pre-line-number">{preLineNumber}</pre>
      <pre className="pre-text">{code + '\n'}</pre>
    </div>
  );
};